function IntroCtrl($state, toastr, AppSettings) {
  'ngInject';

  // ViewModel
  const vm = this;

  vm.isMobile = window.mobilecheck();
  if (location.protocol === 'file:') {
    vm.isMobileApp = true;
  }

  vm.chooseLanguageInfo = function() {
    toastr.info('Choose your language.');
  };

  vm.chooseLanguage = function(lang) {
    var langs = $('.goog-te-menu-frame:first').contents().find('a span.text');
    langs.each(function() {
      var item = $(this);

      if (lang === item.text()) {
        item.click();

        return false;
      }
    });

    var langCode = AppSettings.langCode[lang];

    if (langCode) {
      $state.go('Accounts.login', {lang: langCode});
    } else {
      $state.go('Accounts.login');
    }
  };

}

export default {
  name: 'IntroCtrl',
  fn: IntroCtrl
};
